import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../Axios";
import HeatMap from "../../components/Charts/HeatMap.jsx";
import useAuth from "../../contexts/UserContext.tsx";
import { toast } from "sonner";

export const StudentProgressGrid = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [schoolCourses, setSchoolCourses] = useState();
  const [course, setCourse] = useState();
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataGrid, setDataGrid] = useState();
  const [loading, setLoading] = useState(false);
  const [school, setSchool] = useState("");
  const showBack = user.view_access_list.isIndividualSchool;

  const getSchoolNameByID = async () => {
    await axiosInstance
      .post("getSchoolNameByID", {
        school_id: id,
        user_id: user.user_id,
        auth_token: user.auth_token,
      })
      .then((res) => {
        if (res.data.data.message === "Invalid User") {
          toast.error("Invalid User");
          logout();
          return;
        }
        setSchool(res.data.data.school_name[0].school_name);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getCourses = async () => {
    try {
      const res = await axiosInstance.post("/getCourseForSchools", {
        auth_token: user.auth_token,
        school_id: id,
      });
      if (res.data.data.crs_details.length === 0) {
        toast.error("No courses found for this school.");
      } else {
        setSchoolCourses(res.data.data.crs_details);
        setCourse(res.data.data.crs_details[0].crs_id);
        handleSubmitCourseSelected(res.data.data.crs_details[0].crs_id);
      }
    } catch (err) {
      toast.error("An error occured while fetching courses.");
    }
  };

  const handleSubmitCourseSelected = async (selected_course) => {
    try {
      setLoading(true);
      const res = await axiosInstance.post("/getGridViewStatus", {
        auth_token: user.auth_token,
        school_id: id,
        crs_id: selected_course,
      });
      setDataGrid(res.data.data.student_grid_data);
      console.log("res", res.data.data.student_grid_data);
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDataForGrid = (data, currentPage) => {
    const startIndex = (currentPage - 1) * limit;
    const endIndex = startIndex + limit;

    let newData = [];
    // eslint-disable-next-line array-callback-return
    data?.map((st) => {
      const key = Object.keys(st)[0];
      let filteredData = st[key]?.slice(startIndex, endIndex);
      // eslint-disable-next-line array-callback-return
      filteredData.map((excs) => {
        newData.push({
          student: key,
          exercise: excs.item_title,
          exerciseStatus: excs.excs_mastery_status,
        });
      });
    });
    console.log(newData);
    return newData;
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    let max = 0;
    // eslint-disable-next-line array-callback-return
    dataGrid?.map((st) => {
      const key = Object.keys(st)[0];
      max = Math.max(st[key].length, max);
    });

    const totalDataLength = max;
    const totalPages = Math.ceil(totalDataLength / limit);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(e.target.value);
  };

  useEffect(() => {
    getCourses();
    getSchoolNameByID();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="student-progress-grid-container">
      <>
        <div className="school-name-container flex items-center gap-2">
          {!showBack && (
            <ArrowBackIcon
              className="back-btn hover:cursor-pointer"
              onClick={() => navigate(-1)}
            />
          )}
          <span className="school-name text-[35px] font-bold">{school}</span>
        </div>
        <div className="course-container flex gap-4 mt-4">
          <Box sx={{ width: "100vw" }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Course</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={course}
                label="Course"
                onChange={(e) => setCourse(e.target.value)}
              >
                {schoolCourses &&
                  schoolCourses.map((course, index) => (
                    <MenuItem key={index} value={course.crs_id}>
                      {course.crs_title}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
          <button
            className="course-select-submit-btn bg-blue-500 rounded-md hover:bg-blue-700 w-[100px] text-white"
            onClick={() => handleSubmitCourseSelected(course)}
          >
            Submit
          </button>
        </div>
      </>

      {/* <>
            {dataGrid && <>
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <div style={{float:'right', backgroundColor: "white", padding:"10px"}}>
                                <FormControl >
                                    <InputLabel id="limit">Limit</InputLabel>
                                    <Select
                                        labelId="limit"
                                        id="limit"
                                        value={limit}
                                        label="Limit"
                                        onChange={(e)=> setLimit(e.target.value)}
                                    >
                                        <MenuItem value={20}>20</MenuItem>
                                        <MenuItem value={25}>25</MenuItem>
                                        <MenuItem value={30}>30</MenuItem>
                                        <MenuItem value={40}>40</MenuItem>
                                        <MenuItem value={50}>50</MenuItem>
                                    </Select>
                                </FormControl>
                                <Button className="btn" onClick={handlePrevious} style={{ display: "inline-block"}}>Previous</Button>
                                <Button className="btn" onClick={handleNext} style={{ display: "inline-block"}}>Next</Button>                            
                            </div>
                        </div>
                    </div>
                    <HeatMap data={formatDataForGrid(dataGrid, currentPage)}/>
                </div>
            </>
            }

        </> */}

      {loading ? (
        <div className="flex justify-center items-center h-[500px]">
          <Typography variant="h5" className="text-gray-400">
            Loading...
          </Typography>
        </div>
      ) : (
        <>
          <div className="mt-3 flex justify-end p-3">
            <FormControl>
              <InputLabel id="demo-simple-select-label">Limit</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={limit}
                label="Limit"
                onChange={handleLimitChange}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={15}>15</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={30}>30</MenuItem>
                <MenuItem value={40}>40</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
            <div className="ml-4 flex gap-4">
              <button
                onClick={handlePrevious}
                className="bg-blue-500 rounded-md hover:bg-blue-700 w-[100px] text-white"
              >
                Previous
              </button>
              <button
                onClick={handleNext}
                className="bg-blue-500 rounded-md hover:bg-blue-700 w-[100px] text-white"
              >
                Next
              </button>
            </div>
          </div>
          <div className="heat-map-container">
            <HeatMap data={formatDataForGrid(dataGrid, currentPage)} />
          </div>
        </>
      )}
    </div>
  );
};
